import template from './sw-order-detail-revocation.html.twig';

const { Component } = Shopware;
const { Criteria } = Shopware.Data;

Component.register('sw-order-detail-revocation', {
    template,

    inject: ['repositoryFactory'],

    props: {
        orderId: {
            type: String,
            required: true,
        },
        orderNumber: {
            type: String,
            required: false,
            default: null,
        },
    },

    data() {
        return {
            isLoading: false,
            revocations: [],
        };
    },

    computed: {
        revocationRepository() {
            return this.repositoryFactory.create('jga_revocation');
        },

        revocationColumns() {
            return [
                {
                    property: 'submittedAt',
                    label: this.$tc('jga-revocation.detailCard.labelSubmittedAt'),
                    width: '180px',
                },
                {
                    property: 'customerName',
                    label: this.$tc('jga-revocation.detailCard.labelCustomerName'),
                },
                {
                    property: 'customerEmail',
                    label: this.$tc('jga-revocation.detailCard.labelCustomerEmail'),
                },
                {
                    property: 'reason',
                    label: this.$tc('jga-revocation.detailCard.labelReason'),
                },
            ];
        },
    },

    watch: {
        orderId() {
            this.loadRevocations();
        },
        orderNumber() {
            this.loadRevocations();
        },
    },

    created() {
        this.loadRevocations();
    },

    methods: {
        async loadRevocations() {
            this.isLoading = true;

            try {
                const filters = [Criteria.equals('orderId', this.orderId)];

                if (this.orderNumber) {
                    filters.push(Criteria.equals('orderNumber', this.orderNumber));
                }

                const criteria = new Criteria();
                criteria.addFilter(Criteria.multi('OR', filters));
                criteria.addSorting(Criteria.sort('submittedAt', 'DESC'));

                const result = await this.revocationRepository.search(criteria, Shopware.Context.api);
                this.revocations = [...result];
            } catch (error) {
                this.revocations = [];
            }

            this.isLoading = false;
        },
    },
});
